import 'react-dates/initialize';
import React from 'react';
import { Helmet } from 'react-helmet-async';
import DaApp from '@wix/da-shared-react/pkg/DaApp';
import SiteHeader from '@wix/da-shared-react/pkg/SiteHeader';
import { RuntimeEnvironment } from '@wix/da-shared-react/pkg/types';
import { NotificationQueueItem } from '@wix/da-shared-react/pkg/Notifications';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import ErrorBoundary from '@wix/da-shared-react/pkg/ErrorBoundary';
import SisuFunnelBanner from '@wix/da-shared-react/pkg/SisuFunnelBanner';
import NotificationsDropdownLoadable from '@wix/da-feedback-shared/pkg/NotificationsDropdownLoadable';
import ShowLessNotification from '../ShowLessNotification';
import { NotificationType } from '../../types/notification';
import PageNetworkbar from '../Page';
import s from './App.scss';

export interface Props {
  language: string;
  environment?: RuntimeEnvironment;
  disableBackToTop?: boolean;
  seoNavigation: {
    next?: string;
    prev?: string;
  };
  activeSiteHeaderItem?: string;
  sisuFunnelBannerVisible?: boolean;
  showNetworkBarInSiteHeader?: boolean;
  searchTerm?: string;
}

const renderNotification = (notification: NotificationQueueItem) => {
  switch (notification.type) {
    case NotificationType.SHOW_LESS:
      return (
        <ShowLessNotification
          id={notification.id}
          queueName={notification.queueName}
          type={notification.type}
          {...notification.params}
        />
      );
    default:
      return null;
  }
};

const App: React.FC<Props> = ({
  environment,
  language,
  seoNavigation: { next, prev },
  sisuFunnelBannerVisible,
  showNetworkBarInSiteHeader,
  activeSiteHeaderItem,
  disableBackToTop,
  searchTerm,
}) => {
  const isProto2 = useFlag('feedback_proto_2');
  return (
    <DaApp
      language={language}
      environment={environment}
      backToTopOffset={disableBackToTop ? undefined : 0}
      notificationsRenderFunc={renderNotification}
    >
      <Helmet>
        {next && <link rel="next" href={next} />}
        {prev && <link rel="prev" href={prev} />}
      </Helmet>
      <ErrorBoundary>
        <SiteHeader
          environment={environment}
          showNetworkBar={showNetworkBarInSiteHeader}
          activeMainMenuItem={activeSiteHeaderItem}
          searchQuery={searchTerm}
          notificationsDropdownComponent={
            isProto2 ? NotificationsDropdownLoadable : undefined
          }
        />
        <div className={s['content-container']}>
          <PageNetworkbar />
        </div>
        <SisuFunnelBanner visible={sisuFunnelBannerVisible} />
      </ErrorBoundary>
    </DaApp>
  );
};
App.displayName = 'App';

export default App;
